"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../helpers/parse");
var FormsCollection = /** @class */ (function () {
    function FormsCollection(config, testFeatures) {
        'ngInject';
        this.config = config;
        this.testFeatures = testFeatures;
        Object.defineProperty(this, 'config', { enumerable: false });
        for (var _i = 0, _a = Object.entries(config.forms); _i < _a.length; _i++) {
            var _b = _a[_i], groupName = _b[0], group = _b[1];
            this[groupName] = group;
            for (var _c = 0, _d = Object.entries(group); _c < _d.length; _c++) {
                var _e = _d[_c], formName = _e[0], formConfig = _e[1];
                var form = new FormElement(formConfig);
                this[groupName][formName] = form;
            }
        }
    }
    FormsCollection.prototype.evaluate = function (context) {
        context = Object.assign({
            hasFeature: this.testFeatures.hasFeature.bind(this.testFeatures)
        }, context);
        this.config.eachFormOption(function (option) {
            parse_1.evaluateOptions(option, context);
        });
        return this;
    };
    FormsCollection.prototype.getGroup = function (id, column) {
        var groupForms = [];
        for (var _i = 0, _a = Object.values(this); _i < _a.length; _i++) {
            var group = _a[_i];
            Object.values(group)
                .filter(function (form) { return form.group === id && form.column === column; })
                .forEach(function (form) { return groupForms.push(form); });
        }
        return groupForms;
    };
    FormsCollection.prototype.getColumns = function (id) {
        var columns = [];
        for (var _i = 0, _a = Object.values(this); _i < _a.length; _i++) {
            var group = _a[_i];
            Object.values(group)
                .filter(function (form) { return form.group === id; })
                .forEach(function (form) {
                for (var i = 0; i < form.column; i++) {
                    columns[i] = i + 1;
                }
            });
        }
        return columns;
    };
    return FormsCollection;
}());
exports.FormsCollection = FormsCollection;
var FormElement = /** @class */ (function () {
    function FormElement(config) {
        this.id = config.id;
        this.type = config.type;
        this.label = config.label;
        this.title = config.title;
        this.group = config.group;
        this.column = config.column || 1;
        this.validation = config.validation;
        this.singlecol = config.singlecol;
        this.default = config.default || 0;
        this.reset = config.reset || false;
        this.condition = config.condition;
        this.hidden = config.hidden;
        this.options = config.options.map(function (optionConfig) {
            return new FormElementOption(optionConfig);
        });
        this.checkAllOptions = config.checkAllOptions;
        this.previewPage = config.previewPage;
        this.zoom = config.zoom;
    }
    return FormElement;
}());
exports.FormElement = FormElement;
var FormElementOption = /** @class */ (function () {
    function FormElementOption(config) {
        this.$condition = config.$condition;
        this.$hidden = config.$hidden;
        this.$textValue = config.$textValue;
        this.condition = config.condition;
        this.hidden = config.hidden;
        this.reset = config.reset;
        this.value = config.value;
        this.label = config.label;
        this.image = config.image;
        this.maxCols = config.maxCols;
        this.maxRows = config.maxRows;
        this.maxkb = config.maxkb;
        this.pattern = config.pattern;
        this.placeholder = config.placeholder;
        this.restrict = config.restrict || '.*?';
        this.custom = config.custom;
        this.case = config.case;
        this.property = config.property;
        this.width = config.width;
        this.height = config.height;
        this.previewPage = config.previewPage;
        this.previewZoom = config.previewZoom;
        this.zoom = config.zoom;
        this.class = config.class || config.label || 'option';
        this.dialogOptions = config.dialogOptions;
        this.counterOptions = config.counterOptions;
        this.gmPlacesOptions = config.gmPlacesOptions;
        this.gmStaticOptions = config.gmStaticOptions;
    }
    return FormElementOption;
}());
exports.FormElementOption = FormElementOption;
exports.default = FormsCollection;
